import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useLang } from '../context/LanguageContext';

export default function PrivacyPolicy() {
  const { lang } = useLang();

  return (
    <div style={{ background: '#0A0B0F', minHeight: '100vh' }} className="py-20">
      <div className="max-w-4xl mx-auto px-6">
        <Link 
          to={`/${lang}`}
          className="inline-flex items-center gap-2 text-[#D4AF37] hover:text-[#BFC3C9] transition-colors mb-8"
        >
          <ArrowLeft size={20} />
          <span>{lang === 'ru' ? 'Назад на главную' : 'Volver a inicio'}</span>
        </Link>

        <h1 className="text-4xl md:text-5xl font-black text-white mb-8 font-heading">
          {lang === 'ru' ? 'Политика конфиденциальности' : 'Política de Privacidad'}
        </h1>

        <div className="prose prose-invert max-w-none">
          {lang === 'ru' ? (
            <>
              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">1. Введение</h2>
                <p className="text-[#BFC3C9] mb-4">
                  KIDS MAFIA SL (далее «Компания») с NIF B22815575 и адресом Calle Puebla de Valverde 4, 46014 Valencia, Spain, отвечает за обработку персональных данных, собираемых через данный веб-сайт, в соответствии с Общим регламентом по защите данных (GDPR) ЕС 2016/679 и применимым законодательством Испании.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">2. Собираемые данные</h2>
                <p className="text-[#BFC3C9] mb-4">
                  Мы можем собирать следующие типы персональных данных:
                </p>
                <ul className="text-[#BFC3C9] space-y-2 list-disc pl-6">
                  <li>Контактная информация (имя, email, телефон)</li>
                  <li>Информация о просмотре сайта (cookies, IP-адрес)</li>
                  <li>Информацию, предоставленную добровольно при заполнении форм</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">3. Цели обработки данных</h2>
                <p className="text-[#BFC3C9] mb-4">
                  Ваши данные используются для следующих целей:
                </p>
                <ul className="text-[#BFC3C9] space-y-2 list-disc pl-6">
                  <li>Обработка запросов на информацию о франшизе</li>
                  <li>Связь с потенциальными франчайзи</li>
                  <li>Улучшение работы веб-сайта</li>
                  <li>Соблюдение юридических обязательств</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">4. Правовые основания обработки</h2>
                <p className="text-[#BFC3C9] mb-4">
                  Обработка ваших данных основывается на:
                </p>
                <ul className="text-[#BFC3C9] space-y-2 list-disc pl-6">
                  <li>Ваше согласие при отправке форм или использовании cookies</li>
                  <li>Выполнение договора или предварительных действий по его заключению</li>
                  <li>Законные интересы Компании</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">5. Ваши права</h2>
                <p className="text-[#BFC3C9] mb-4">
                  Вы имеете право на:
                </p>
                <ul className="text-[#BFC3C9] space-y-2 list-disc pl-6">
                  <li>Доступ к своим персональным данным</li>
                  <li>Исправление неточных данных</li>
                  <li>Удаление данных («право на забвение»)</li>
                  <li>Ограничение обработки данных</li>
                  <li>Отзыв согласия в любое время</li>
                  <li>Переносимость данных</li>
                  <li>Подача жалобы в надзорный орган</li>
                </ul>
                <p className="text-[#BFC3C9] mt-4">
                  Для реализации своих прав направьте запрос на: <a href="mailto:kidsmafia.vlc@gmail.com" className="text-[#D4AF37] hover:underline">kidsmafia.vlc@gmail.com</a>
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">6. Хранение данных</h2>
                <p className="text-[#BFC3C9] mb-4">
                  Ваши персональные данные хранятся только в течение периода, необходимого для достижения целей обработки, или в соответствии с законодательными требованиями.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">7. Передача данных</h2>
                <p className="text-[#BFC3C9] mb-4">
                  Ваши данные не передаются третьим лицам, за исключением случаев, когда это требуется законодательством или для предоставления запрошенных услуг.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">8. Безопасность</h2>
                <p className="text-[#BFC3C9] mb-4">
                  Мы применяем соответствующие технические и организационные меры для защиты ваших персональных данных от несанкционированного доступа, изменения, раскрытия или уничтожения.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">9. Контакты</h2>
                <p className="text-[#BFC3C9] mb-4">
                  По вопросам защиты данных обращайтесь:<br />
                  <strong>Email:</strong> <a href="mailto:kidsmafia.vlc@gmail.com" className="text-[#D4AF37] hover:underline">kidsmafia.vlc@gmail.com</a><br />
                  <strong>Адрес:</strong> Calle Puebla de Valverde 4, 46014 Valencia, Spain
                </p>
              </section>
            </>
          ) : (
            <>
              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">1. Introducción</h2>
                <p className="text-[#BFC3C9] mb-4">
                  KIDS MAFIA SL (en adelante, «la Empresa») con NIF B22815575 y domicilio en Calle Puebla de Valverde 4, 46014 Valencia, Spain, es responsable del tratamiento de los datos personales recogidos a través de este sitio web, de conformidad con el Reglamento General de Protección de Datos (RGPD) UE 2016/679 y la legislación española aplicable.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">2. Datos Recogidos</h2>
                <p className="text-[#BFC3C9] mb-4">
                  Podemos recoger los siguientes tipos de datos personales:
                </p>
                <ul className="text-[#BFC3C9] space-y-2 list-disc pl-6">
                  <li>Información de contacto (nombre, email, teléfono)</li>
                  <li>Información de navegación (cookies, dirección IP)</li>
                  <li>Información proporcionada voluntariamente al completar formularios</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">3. Finalidades del Tratamiento</h2>
                <p className="text-[#BFC3C9] mb-4">
                  Sus datos se utilizan para las siguientes finalidades:
                </p>
                <ul className="text-[#BFC3C9] space-y-2 list-disc pl-6">
                  <li>Gestión de solicitudes de información sobre la franquicia</li>
                  <li>Comunicación con potenciales franquiciados</li>
                  <li>Mejora del funcionamiento del sitio web</li>
                  <li>Cumplimiento de obligaciones legales</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">4. Base Legal del Tratamiento</h2>
                <p className="text-[#BFC3C9] mb-4">
                  El tratamiento de sus datos se basa en:
                </p>
                <ul className="text-[#BFC3C9] space-y-2 list-disc pl-6">
                  <li>Su consentimiento al enviar formularios o usar cookies</li>
                  <li>La ejecución de un contrato o medidas precontractuales</li>
                  <li>Intereses legítimos de la Empresa</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">5. Sus Derechos</h2>
                <p className="text-[#BFC3C9] mb-4">
                  Usted tiene derecho a:
                </p>
                <ul className="text-[#BFC3C9] space-y-2 list-disc pl-6">
                  <li>Acceder a sus datos personales</li>
                  <li>Rectificar datos inexactos</li>
                  <li>Suprimir sus datos («derecho al olvido»)</li>
                  <li>Limitar el tratamiento de sus datos</li>
                  <li>Retirar el consentimiento en cualquier momento</li>
                  <li>Portabilidad de datos</li>
                  <li>Presentar una reclamación ante la autoridad de control</li>
                </ul>
                <p className="text-[#BFC3C9] mt-4">
                  Para ejercer sus derechos, envíe una solicitud a: <a href="mailto:kidsmafia.vlc@gmail.com" className="text-[#D4AF37] hover:underline">kidsmafia.vlc@gmail.com</a>
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">6. Conservación de Datos</h2>
                <p className="text-[#BFC3C9] mb-4">
                  Sus datos personales se conservan únicamente durante el tiempo necesario para cumplir con las finalidades del tratamiento o según lo exija la legislación.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">7. Cesión de Datos</h2>
                <p className="text-[#BFC3C9] mb-4">
                  Sus datos no se ceden a terceros, salvo cuando sea requerido por ley o para prestar los servicios solicitados.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">8. Seguridad</h2>
                <p className="text-[#BFC3C9] mb-4">
                  Aplicamos medidas técnicas y organizativas apropiadas para proteger sus datos personales contra acceso no autorizado, alteración, divulgación o destrucción.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">9. Contacto</h2>
                <p className="text-[#BFC3C9] mb-4">
                  Para cuestiones sobre protección de datos, contacte con nosotros:<br />
                  <strong>Email:</strong> <a href="mailto:kidsmafia.vlc@gmail.com" className="text-[#D4AF37] hover:underline">kidsmafia.vlc@gmail.com</a><br />
                  <strong>Domicilio:</strong> Calle Puebla de Valverde 4, 46014 Valencia, Spain
                </p>
              </section>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
